var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 110,
    viewBox: "0 0 109 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 93,
    height: 94,
    rx: 12,
    fill: "#F8F9FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1803_12833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2344 24.7763H29.7656V82.2237H77.2344V24.7763ZM29 24V83H78V24H29Z",
    fill: "#000B32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 33H69V33.7755H38V33ZM69 39.2041H38V39.9796H69V39.2041ZM69 45.4082H38V46.1837H69V45.4082ZM69 57.8163H38V58.5918H69V57.8163ZM38 64.0204H61.25V64.7959H38V64.0204ZM58.925 70.2245H38V71H58.925V70.2245ZM38 51.6122H69V52.3878H38V51.6122Z",
    fill: "#000B32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8462 69.5391L81.2609 72.4491L85.7332 72.8059L86.0901 77.2782L89.0001 80.6929L86.0901 84.1076L85.7332 88.5799L81.2609 88.9368L77.8462 91.8468L74.4315 88.9368L69.9593 88.5799L69.6024 84.1076L66.6924 80.6929L69.6024 77.2782L69.9593 72.8059L74.4315 72.4491L77.8462 69.5391Z",
    fill: "#1462D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0987 76.2433L74.9562 82.2198L71.541 78.8968L72.6139 77.7942L74.9562 80.0732L80.0259 75.1406L81.0987 76.2433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7229 70.91L76.3081 68L72.8934 70.91L68.4212 71.2669L68.0643 75.7391L65.1543 79.1538L68.0643 82.5686L68.4212 87.0408L72.8934 87.3977L76.3081 90.3077L79.7229 87.3977L84.1951 87.0408L84.552 82.5686L87.462 79.1538L84.552 75.7391L84.1951 71.2669L79.7229 70.91ZM83.4805 71.9815L79.4134 71.657L76.3081 69.0107L73.2028 71.657L69.1358 71.9815L68.8113 76.0485L66.165 79.1538L68.8113 82.2591L69.1358 86.3262L73.2028 86.6507L76.3081 89.297L79.4134 86.6507L83.4805 86.3262L83.805 82.2591L86.4513 79.1538L83.805 76.0485L83.4805 71.9815Z",
    fill: "#000B32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1803_12833",
    x: -4,
    y: 0,
    width: 117,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1803_12833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1803_12833",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.fd2c236e.svg";
export { ForwardRef as ReactComponent };